/**
 * Spacing 토큰 — 4px 기반 간격 스케일
 */

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
} as const

export type SpacingKey = keyof typeof spacing

// Helper functions for class names
export const getSpacingClass = (level: SpacingKey, property: 'margin' | 'padding' = 'padding') => {
  const prop = property === 'margin' ? 'm' : 'p'
  return `${prop}-${level}` as const
}

export const getSpacingValue = (level: SpacingKey): string => spacing[level]
